import { type ReactNode } from 'react'
import { createPortal } from 'react-dom'

/**
 * Mounts the in-app fullscreen viewer on document.body so its z-index can
 * cover the chatbot dock and homebar.
 */
export function DocumentFullscreenPortal({
  isDocumentFullscreen,
  children,
}: {
  isDocumentFullscreen: boolean
  children: ReactNode
}) {
  if (!isDocumentFullscreen) {
    return children
  }

  return createPortal(children, document.body)
}
